import { z } from "zod";

/** URL de profil LinkedIn (unicité) — persiste pour ré-import rapide. */
export const LINKEDIN_URL_RE =
  /^https?:\/\/(www\.)?[a-z]{2,3}\.linkedin\.com\/in\/[A-Za-z0-9_\-.]{2,}\/?$/;

/** Création d'un job d'import (utilisateur connecté, consentement). */
export const CreateLinkedInImportDtoSchema = z.object({
  url: z
    .string()
    .trim()
    .min(10)
    .max(512)
    .regex(LINKEDIN_URL_RE, "URL LinkedIn invalide (format : linkedin.com/in/...)"),
  consent: z.boolean().refine((value) => value, {
    message: "Vous devez confirmer que vous importez VOTRE propre profil.",
  }),
});
export type CreateLinkedInImportDto = z.infer<typeof CreateLinkedInImportDtoSchema>;

/** Réponse de création d'un job. */
export const LinkedInImportStartedDtoSchema = z.object({
  jobId: z.string(),
  status: z.literal("PENDING"),
  provider: z.literal("brightdata"),
});
export type LinkedInImportStartedDto = z.infer<typeof LinkedInImportStartedDtoSchema>;

/**
 * Statut + résultats d'un job (progression) :
 *  - PENDING/RUNNING : `ready = false`, on re-polle ;
 *  - DONE : `ready = true`, `draft` contient le profil normalisé à prévisualiser ;
 *  - FAILED : `ready = true`, `error` est lisible pour l'utilisateur.
 */
export const LinkedInImportStatusDtoSchema = z.object({
  jobId: z.string(),
  ready: z.boolean(),
  status: z.enum(["PENDING", "RUNNING", "DONE", "FAILED"]),
  draft: z.unknown().optional(),
  error: z.string().optional(),
});
export type LinkedInImportStatusDto = z.infer<typeof LinkedInImportStatusDtoSchema>;

/** Confirmation après prévisualisation — crée réellement le CV. */
export const ConfirmLinkedInImportDtoSchema = z.object({
  jobId: z.string().min(1),
});
export type ConfirmLinkedInImportDto = z.infer<typeof ConfirmLinkedInImportDtoSchema>;
